import React from 'react';
import OpportunitiesCardFooter from './OpportunitiesCardFooter';
import OpportunitiesCardTitle from './OpportunitiesCardTitle';
import OpportunitiesCardDetail from './OpportunitiesCardDetail';
import OpportunitiesCardCurrentStatus from './OpportunitiesCardCurrentStatus';
import { UIApplication, ApplicationStatus, UserCareerPathType, WorkingMode } from 'types';
import { closedApplicationStatuses, formatCareerPathType } from 'shared-utils';
import { Button } from 'flowbite-react';
import { useSearchParams } from 'react-router-dom';

const MyOpportunitiesDriveCard = ({
	application,
	setSelectedApplication,
}: {
	application: UIApplication;
	setSelectedApplication: React.Dispatch<React.SetStateAction<UIApplication | null>>;
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	return (
		<>
			<div className="rounded-[12px] border dark:border-[#3F3F3F] max-w-full md:max-w-[760px] relative">
				<div
					className={
						'grid md:flex justify-between px-[12px] py-[16px] dark:bg-[#1F2A37] bg-white rounded-tl-[12px] rounded-tr-[12px]'
					}
				>
					<div>
						<OpportunitiesCardTitle
							companyUrl={application.position?.company.url || ''}
							companyImg={application.position?.company.logo || ''}
							companyName={application.position?.company.name || ''}
							positionTitle={formatCareerPathType(application.position?.title as UserCareerPathType) || ''}
						/>
						<OpportunitiesCardDetail
							workingMode={application.position?.workingMode || ''}
							minSalary={String(application.position?.salary?.min) || ''}
							maxSalary={String(application.position?.salary?.max) || ''}
							internshipSalary={application.position?.internshipSalary}
							internshipDuration={application.position?.internshipDuration}
							location={
								Array.isArray(application.position?.workLocations)
									? application.position?.workLocations.map(location => location.split(',')[0].trim()).join(', ')
									: application.position?.workLocations || ''
							}
							type={application.position?.positionType || ''}
						/>
					</div>
					<div className="absolute md:static -top-3 right-1">
						<OpportunitiesCardCurrentStatus currentStatus={application.status} />
					</div>
				</div>

				{[
					ApplicationStatus.OFFER_ROLLED_OUT,
					ApplicationStatus.CHANGED_OFFER_TERMS,
					ApplicationStatus.VERBALLY_PLACED,
					ApplicationStatus.PLACED,
				].includes(application.status) ? (
					<div className="flex gap-[12px] py-2 px-3 justify-end">
						<Button
							onClick={e => {
								e.stopPropagation();
								searchParams.set('viewOffer', application._id || ''); // Set new or update existing param
								setSearchParams(searchParams);
								setSelectedApplication(application);
							}}
							color="purplePlaced"
							size={'sm'}
						>
							View Offer
						</Button>
					</div>
				) : (
					<OpportunitiesCardFooter
						footerText={`Round Location: Floor ${application.position?.company?.offlineDriveRoom?.floorName || ''
							}, Room ${application.position?.company?.offlineDriveRoom?.roomName || ''} ${application.position?.company?.offlineDriveRoom?.buildingName || ''
							}`}
						room={application.position?.company?.offlineDriveRoom?.floorName}
						floor={application.position?.company?.offlineDriveRoom?.buildingName}
					/>
				)}
			</div>
		</>
	);
};

export default MyOpportunitiesDriveCard;
